import React, { useState,useEffect,useRef } from 'react';
import { Row, Col } from "react-bootstrap";
import * as Mui  from '@mui/material';
import Datex from '@drumtj/datex';
import Home from './Home'
import Transport from './Transport';
import '../lib/bootstrap.min.css'
import './Main.css';
import Fnb from './Fnb';
import Clock from './ClockWidget';
import RoomService from './RoomService';
import Property from './Property';
import Welcome from './Welcome';
import License from './License';
import dba from '../lib/db.json';
import Promo from './Promo';
import { useParams } from "react-router-dom";

const Preview = (props) => {

    const path  = useParams()
    var _valid = 100;
    const db = JSON.parse(JSON.stringify(dba))

    const[openAlert,setOpenAlert] = useState(false)

    const [profileHome,setProfileHome] = useState()
    const [profileProperty,setProfileProperty] = useState()
    const [profileOverview,setProfileOverview] = useState()
    const [profileClock,setProfileClock] = useState()
    const [profileTransport,setProfileTransport] = useState()
    const [profileFnb,setProfileFnb] = useState()
    const [profilePromo,setProfilePromo] = useState()

    const [roomActive, setRoomActive] = useState()
    const [roomServices,setRoomServices] = useState()

    const [hWindow, setHWindow] = useState(0);
    const [hHeader, setHHeader] = useState(110);
    const [hContent, setHContent] = useState(352);
    const [hFooter, setHFooter] = useState(80);


    const [loading,setLoading] = useState(false);
    const [loadingGetData,setLoadingGetData] = useState(true);

    const [isPage, setIsPage] = useState('property');
    const [background,setBackground] = useState()
    const [clickCount,setClickCount] = useState(0)
    const [openModal,setOpenModal] = useState(false)
    const [weatherLoading, setWeatherLoading] = useState(false);
    /*const [weather,setWeather] = React.useState({
        lat: db.profile_device[0].content.home_page.weather.lat,
        lon: db.profile_device[0].content.home_page.weather.lon,
        key:'0f1903d6af398d812da36080b1c80065',
        unit:'metric'
      })*/

    const ref = useRef(null);
    const worldClockRef = useRef()
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)
    
    const openPage = (page) =>{
        switch(isPage) {
            case 'home':
                if(isPage==='home' && page === 'home'){
                    setClickCount(clickCount+1)
                    if(clickCount>19){
                        setOpenModal(true)
                        /*var return_value=prompt("Password:");
                        if(return_value==="4554"){
                            page = 'setting'
                            setClickCount(0)
                        }*/
                    }
                }
              break;
            case 'worldclock':
                setClickCount(0)
                worldClockRef.current.exitPage()
              break;
            default:
                setClickCount(0)
          }
        setIsPage(page)
    }

    const getData = () => {
        setLoading(true)
          
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("path", path.id)

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
            
        fetch(props.config.hostApi + "app/profile/profile-path", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if(result.success){
                setProfileHome(result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail)

                setBackground(result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'background')[0].value)
                var weatherLat = result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_lat')[0].value
                var weatherLon = result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_lon')[0].value
                var weatherKey = result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_key')[0].value
                var weatherUnit=result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_unit')[0].value
                getWeather(weatherLat,weatherLon,weatherKey,weatherUnit)

                setProfileProperty(result.data.object_profile)

                var mappingTimezone = []
                for(var i =0; i < 5; i++){ 
                    mappingTimezone[i] = {
                        id: "timezone_"+(i+1),
                        timezone: result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'clock_timezone')[0].object_detail.filter((_profile)=> _profile.object === 'timezone_'+(i+1))[0].value,
                        title: result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'clock_timezone')[0].object_detail.filter((_profile)=> _profile.object === 'title_'+(i+1))[0].value
                    }
                }
                setProfileClock(mappingTimezone)

                setProfileTransport(result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'transport')[0].object_detail)

                setProfileFnb(result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'restaurant')[0].object_detail)

                //console.log(result.data.object_profile)
                setProfilePromo(result.data.object_profile.filter((object_profile)=> object_profile.object_name === 'promo')[0].object_detail)

                //console.log(result.data)
                setRoomActive(null)
                getRoomServices('')

                setLoading(false)
                setLoadingGetData(false)
            }else{
                setLoading(false);
            
            }
        })
        .catch((error) => {
            setLoading(false);
        })
            
        setLoading(false)
    };

    const getRoomServices = (reservation_key) => {
        setLoading(true)
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("reservation_key",reservation_key)

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
            
        fetch(props.config.hostApi + "mobile/room-service", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            //console.log(reservation_key)
            //console.log(result)
            if(result.success){
                setRoomServices(result.data.room_services)
                setLoading(false)
            }else{
                setLoading(false);
            }
        })
        .catch((error) => {
            setLoading(false);
            
        })
            
        //setLoading(false)
    };

    const getWeather = (lat,lon,key,unit) =>{
        setWeatherLoading(true)
        const myHeaders = new Headers();
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch('https://api.openweathermap.org/data/2.5/weather?lat='+lat+'&lon='+lon+'&appid='+key+'&units='+unit, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                document.getElementById("weather_city").innerHTML = result.name+`<br />`+ new Datex(Date.now()).format("DDD, DD MMM YYYY")
                document.getElementById("weather_time").innerHTML = new Datex(Date.now()).format("hh:mm")
                document.getElementById("weather_icon").innerHTML = `
                <img src='https://rodrigokamada.github.io/openweathermap/images/`+result.weather[0].icon + `_t@2x.png' height='80' alt='weather' />`
                document.getElementById("weather_temp").innerHTML = parseInt(result.main.temp)+`<sup> o</sup>`
                
                setWeatherLoading(false)
            })
            .then((error)=>{
                setWeatherLoading(false)
            })
        
    }
    
    useEffect(() => {
        getData()
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
        setHWindow(ref.current.clientHeight);
    },[]);


  return (
    <>
        <style>{`
            .tv{
                background:linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url('`+ background +`') no-repeat;
                background-size: cover;
            }
            .header{
                height: `+hHeader+`px;
            }
            .content{
                height: `+hContent+`px;
            }
            .footer{
                height: `+hFooter+`px;
            }
            #modal-modal-description .btnHome{
                min-width:170px;
                margin: 0 5px 10px 5px
            }
        `}</style>
        <Mui.Modal
            open={openModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Mui.Box style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                background: '#ffffff',
                color: '#000000',
                border: '0px solid #000',
                boxShadow: 24,
                padding: '5px 15px',
            }}>
            <Mui.Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <button className="btnHome"  onClick={()=>{window.ReactNativeWebView.postMessage("openSetting")}}>
                        Setting
                    </button>
                    <button className="btnHome" onClick={()=>{window.ReactNativeWebView.postMessage("openConsole")}}>
                        Open Console
                    </button>
                    <button className="btnHome"  onClick={()=>{window.ReactNativeWebView.postMessage("openLauncher")}}>
                        Activate TV
                    </button>
                    <button className="btnHome"  onClick={()=>{setOpenModal(false); setClickCount(0)}}>
                        Close 
                    </button>
            </Mui.Typography>
            </Mui.Box>
        </Mui.Modal>
        <Mui.Backdrop
          sx={(theme) => ({ backgroundColor:'red', color: '#fff', zIndex: 999 })}
          open={loading}
        >
            <Mui.CircularProgress color="inherit" /> 
            <Mui.Typography style={{marginLeft: '30px'}}>Please wait..</Mui.Typography>
        </Mui.Backdrop>
        <div className='tv' id='tv' ref={ref}>
            <div id='sn' style={{display:'none'}}></div>
            <Row className='header' id='header'>
                <Col md={7}>
                    <div className='header-left'>      
                        <div className="logo"><img src={db.profile_device[0].content.home_page.logo} alt='logo' /></div>
                    </div>
                </Col>
                <Col md={5}>
                    <div className='header-right'>
                        <div className='weather' id='weather'>
                            <div id='weather_city'></div>
                            <div id='weather_time'></div>
                            <div id='weather_icon'></div>
                            <div id='weather_temp'></div>
                        </div>
                    </div>
                </Col>
            </Row>
            { loadingGetData === false && 
            <div className='content'>
                {isPage === 'license' && (<License height={hContent} valid={_valid} goToHome={()=>{openPage('welcome')}} />)}
                {isPage === 'welcome' && (<Welcome height={hContent} db={db} goToHome={()=>{openPage('home')}} />)}
                {isPage === 'home' && (
                    <Home height={hContent} 
                        profile={profileHome}  
                        reservation = {roomActive}
                        propertyInfo={()=>{openPage('property')}} 
                    />
                )}

                {isPage === 'roomservice' && (
                    <RoomService 
                        height={hContent}
                        config = {props.config}
                        roomServices = {roomServices}
                        reservation = {roomActive}
                        refresh = {getData}
                    
                    />)}

                {isPage === 'worldclock' && (
                    <Clock ref={worldClockRef} 
                        height={hContent} 
                        profile={profileClock}
                        page={isPage} 
                    />
                )}

                {isPage === 'transport' && (
                    <Transport 
                            height={hContent} 
                            profile={profileTransport}
                            page={isPage}
                    />)}   

                {isPage === 'fnb' && (
                    <Fnb 
                            height={hContent} 
                            profile={profileFnb}
                            page={isPage}
                    />)}   

                {isPage === 'property' && (
                    <Property 
                        height={hContent} 
                        profile={profileProperty} 
                        reservation = {roomActive}
                        page={isPage}  
                    />
                )}

                {isPage === 'promo' && (
                    <Promo 
                        height={hContent} 
                        profile={profilePromo} 
                        //guide={db.profile_device[0].content.promo_guide} 
                    />)}

                {isPage === 'promo1' && (
                    <Promo 
                        height={hContent} 
                        content={db.profile_device[0].content.promo} 
                        guide={db.profile_device[0].content.promo_guide} 
                    />)}
            </div>
            }
            <Row className='footer' id='footer'>
               <Col md={12}>
                    <button className='bmenu' tabIndex={1} 
                        onClick={()=>{ 
                            //openPage('home')
                            openPage('property')
                        }}
                    >
                        <img src='/icons/home.png' alt='Property' height={27} />
                    </button>
                    <button className='bmenu' tabIndex={1} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/tv.png' alt='Tv Channel' height={28} />
                    </button>
                    <button className='bmenu' tabIndex={2} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/youtube.png' alt='Youtube' height={24} />
                    </button>
                    <button className='bmenu' tabIndex={3} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/netflix.png' alt='Netflix' height={17} />
                    </button>
                    <button className='bmenu' tabIndex={4} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/prime-video.png' alt='Prime Video' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={5} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/vidio.png' alt='Vidio' height={22} />
                    </button>
                    <button className='bmenu' tabIndex={7} onClick={()=>{setOpenAlert(true)}}>
                        <img src='/icons/disney.png' alt='Disney +' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={8} onClick={()=>{ openPage('worldclock')}}>
                        <img src='/icons/worldclock.png' alt='World Clock' height={32} />
                    </button>
                    {/*<button className='bmenu' tabIndex={9} onClick={()=>{ openPage('flight')}}>
                        <img src='/icons/flight.png' alt='Flight Schedule' height={32} />
                    </button>*/}
                    <button className='bmenu' tabIndex={10} onClick={()=>{ openPage('transport')}}>
                        <img src='/icons/transport.png' alt='Transport' height={26} />
                    </button>
                    <button className='bmenu' tabIndex={11} onClick={()=>{ openPage('fnb')}}>
                        <img src='/icons/fnb.png' alt='Food and Beverage' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={8} onClick={()=>{ openPage('promo')}}>
                        <img src='/icons/discount.png' alt='Promo' height={32} />
                    </button>
                    {/*<button className='bmenu' tabIndex={12} onClick={()=>{ 
                        setOpenAlert(true)
                    }}>
                        <img src='/icons/helpdesk.png' alt='Helpdesk' height={32} />
                    </button>
                   <button className='bmenu' tabIndex={12} onClick={()=>{ openPage('wifi')}}>
                        <img src='icons/wifi.png' alt='Wifi' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={13} onClick={()=>{ openPage('wakeupcall')}}>
                        <img src='icons/wake-up.png' alt='Wakeup Call' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={13} onClick={()=>{ openPage('settings')}}>
                        <img src='icons/settings.png' alt='Settings' height={27} />
                    </button>*/}
                    
                </Col>
            </Row>
            <Mui.Snackbar open={openAlert} autoHideDuration={6000} onClose={()=>{setOpenAlert(false)}}>
                <Mui.Alert
                onClose={()=>{setOpenAlert(false)}}
                severity="warning"
                variant="filled"
                sx={{ width: '100%' }}
                >
                This action is not allowed on Preview Mode !
                </Mui.Alert>
            </Mui.Snackbar>
        </div>
    </>
  );
};

export default Preview;


